import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { APP_CONFIG } from './core/config.ts';
import './index.css';

document.documentElement.lang = APP_CONFIG.locale;
document.documentElement.dir = APP_CONFIG.direction;

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
